// extracted by mini-css-extract-plugin
export default {"gnb":"Header_gnb__+Hb-A","title":"Header_title__x3ga3"};